import React, { PropTypes } from "react";

export default function FacetView({ label, children }) {
    return (
      <fieldset className="filter filter-block col-lg-3 col-sm-4">
        <h2 className="filter-title">{label}</h2>
        <div className="contents filter-list">{children}</div>
      </fieldset>
    );
}
FacetView.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.symbol,
    ]),
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Views/FacetView.jsx